import { c as _c } from "react/compiler-runtime";
import { chakra, Box, Button, Center, Heading, HStack, Text, VStack, Wrap, StackProps, BadgeProps, Badge, Separator } from '@chakra-ui/react';
import { ChevronRightIcon } from '@src/components/sco/icons.tsx';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { SIGNUP_PATHS } from '@src/constants/navigation';
import { ScoProduct } from '@src/graphql-types';
import tracker from '@src/lib/tracker';
import moment from 'moment/moment';
import React from 'react';
export type PaywallProductCardProps = {
  badgeProps?: BadgeProps;
  paymentPath?: string;
  product: Partial<ScoProduct>;
  isSpecialOffer?: boolean;
  hideFeatures?: boolean;
  hideDiscountEffects?: boolean;
  onSelect?: (args: {
    productId?: string;
    couponCode?: string;
    termId?: string;
  }) => any;
  showTermInTitle?: boolean;
  containerProps?: StackProps;
  title?: string;
  description?: string;
  renderFeatures?: () => any;
};
export const PaywallProductCard = props => {
  const $ = _c(76);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const product = props.product;
  let t0;
  if ($[0] !== product.effectivePricingInCents || $[1] !== product.pricingInCents) {
    t0 = product.effectivePricingInCents || product.pricingInCents || {};
    $[0] = product.effectivePricingInCents;
    $[1] = product.pricingInCents;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const pricing = t0;
  const isRecurringDifferent = pricing.signup != pricing.recurring && (product.effectiveTermId !== "one" || product.appliedCoupon);
  const isRecurringDiscounted = pricing.recurring != product.pricingInCents.recurring;
  const isSpecialOffer = !props.hideDiscountEffects && (isRecurringDifferent || isRecurringDiscounted || pricing.trialDays > 0 || props.isSpecialOffer);
  let t1;
  if ($[3] !== pricing.signup) {
    t1 = (pricing.signup / 100 || 0).toLocaleString("en-US", {
      minimumFractionDigits: 2
    }).replace(".00", "").split(".");
    $[3] = pricing.signup;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const prettySignupPriceParts = t1;
  const t2 = isSpecialOffer ? "6px" : 0;
  const t3 = isSpecialOffer ? "3xl" : "lg";
  const t4 = isSpecialOffer ? "-6px" : 0;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = ["100%", "100%", "480px"];
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = props.containerProps;
  let t7;
  if ($[6] !== getBreakpointValue) {
    t7 = getBreakpointValue({
      base: "1.5em",
      lg: "2.5em 2em 2em 2em"
    });
    $[6] = getBreakpointValue;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== props.badgeProps) {
    t8 = props.badgeProps && <Badge {...props.badgeProps} />;
    $[8] = props.badgeProps;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const t9 = props.title || props.product.paywallOptions?.title || props.product.title || "Product";
  let t10;
  if ($[10] !== props.product || $[11] !== props.showTermInTitle) {
    t10 = props.showTermInTitle && <><br />{props.product.effectiveTerm.name}</>;
    $[10] = props.product;
    $[11] = props.showTermInTitle;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10 || $[14] !== t9) {
    t11 = <Heading size="3xl">{t9}{t10}</Heading>;
    $[13] = t10;
    $[14] = t9;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== props.description || $[17] !== props.product) {
    t12 = (props.description || props.product.paywallOptions?.description) && <Text marginX="auto" marginY="0.25em">{props.description || props.product.paywallOptions?.description}</Text>;
    $[16] = props.description;
    $[17] = props.product;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t11 || $[20] !== t12 || $[21] !== t7 || $[22] !== t8) {
    t13 = <Box padding={t7} textAlign="center">{t8}{t11}{t12}</Box>;
    $[19] = t11;
    $[20] = t12;
    $[21] = t7;
    $[22] = t8;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Heading alignSelf="flex-start" fontSize="md" lineHeight={1} paddingTop="0.1em">$</Heading>;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== prettySignupPriceParts[0]) {
    t15 = <Heading lineHeight={1} size="5xl" textAlign="center">{prettySignupPriceParts[0]}</Heading>;
    $[25] = prettySignupPriceParts[0];
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== prettySignupPriceParts[1]) {
    t16 = prettySignupPriceParts[1] ? <Heading alignSelf="flex-start" fontSize="md" lineHeight={1} paddingTop="0.1em">.{prettySignupPriceParts[1]}</Heading> : "";
    $[27] = prettySignupPriceParts[1];
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== isRecurringDifferent || $[30] !== product.effectiveTerm) {
    t17 = !isRecurringDifferent ? <Heading alignSelf="flex-end" fontSize="sm" lineHeight={1} paddingBottom="0.5em" paddingTop="0.1em">{"/ "}{product.effectiveTerm.abbreviation}</Heading> : <></>;
    $[29] = isRecurringDifferent;
    $[30] = product.effectiveTerm;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== t15 || $[33] !== t16 || $[34] !== t17) {
    t18 = <HStack align="center" gap={1} justify="center">{t14}{t15}{t16}{t17}</HStack>;
    $[32] = t15;
    $[33] = t16;
    $[34] = t17;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== isRecurringDifferent || $[37] !== isRecurringDiscounted || $[38] !== isSpecialOffer || $[39] !== pricing.recurring || $[40] !== pricing.trialDays || $[41] !== pricing.trialRequiresCard || $[42] !== product.effectiveTermId || $[43] !== product.pricingInCents.recurring || $[44] !== product.pricingInCents.signup || $[45] !== props.product) {
    t19 = isSpecialOffer && <Text color="colorPalette.fg" fontFamily="Poppins" fontSize="0.8em" marginTop="0.5em">{isRecurringDiscounted && <><chakra.strong bgColor="colorPalette.fg/80" borderRadius="1em" color="colorPalette.bg" display="inline-block" marginBottom="0.25em" padding="0.125em 1em" textTransform="uppercase">Special Offer Applied</chakra.strong><br /><chakra.span display="inline-block" marginY={1} opacity={0.67} textDecoration="line-through">Normally ${((product.pricingInCents.recurring || product.pricingInCents.signup) / 100 || 0).toLocaleString("en-US", {})}{props.product.effectiveTerm.abbreviation !== "once" && <>/{props.product.effectiveTerm.abbreviation}</>}</chakra.span><br /></>}{isRecurringDifferent && <><chakra.strong bgColor="colorPalette.fg/80" borderRadius="1em" color="colorPalette.emphasized" display="inline-block" marginBottom="0.25em" padding="0.125em 1em" textTransform="uppercase">{pricing.trialDays ? [`Free ${pricing.trialDays}-Day Trial`, !pricing.trialRequiresCard && "\u2022 No Card Required"].filter(Boolean).join("") : product.effectiveTermId == "one" ? "Lifetime Special Offer" : `First ${props.product.effectiveTerm.everyMonthLabel} Special Offer`}</chakra.strong><br />{product.effectiveTermId === "one" ? <></> : <chakra.span display="inline-block" marginY={1} opacity={0.67}>Renews at ${(pricing.recurring / 100 || 0).toLocaleString("en-US", {})}/{props.product.effectiveTerm.abbreviation}{props.product.effectivePricingInCents?.nextAssessmentAt ? `, starting on ${moment(props.product.effectivePricingInCents.nextAssessmentAt).format("ll")}` : ""}. Cancel anytime.</chakra.span>}</>}</Text>;
    $[36] = isRecurringDifferent;
    $[37] = isRecurringDiscounted;
    $[38] = isSpecialOffer;
    $[39] = pricing.recurring;
    $[40] = pricing.trialDays;
    $[41] = pricing.trialRequiresCard;
    $[42] = product.effectiveTermId;
    $[43] = product.pricingInCents.recurring;
    $[44] = product.pricingInCents.signup;
    $[45] = props.product;
    $[46] = t19;
  } else {
    t19 = $[46];
  }
  let t20;
  if ($[47] !== t18 || $[48] !== t19) {
    t20 = <Box paddingX="2em" textAlign="center">{t18}{t19}</Box>;
    $[47] = t18;
    $[48] = t19;
    $[49] = t20;
  } else {
    t20 = $[49];
  }
  let t21;
  if ($[50] !== getBreakpointValue) {
    t21 = getBreakpointValue({
      base: "1em",
      lg: "2em"
    });
    $[50] = getBreakpointValue;
    $[51] = t21;
  } else {
    t21 = $[51];
  }
  let t22;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <ChevronRightIcon />;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  const t23 = `${props.paymentPath || SIGNUP_PATHS.payment}?productId=${product.productId}&termId=${product.effectiveTermId}&couponCode=${product.appliedCoupon?.code || ""}`;
  let t24;
  if ($[53] !== product || $[54] !== props) {
    t24 = e => {
      tracker.productSelected({
        product: product as ScoProduct
      });
      if (props.onSelect) {
        e.preventDefault();
        props.onSelect({
          productId: product.productId,
          couponCode: product.appliedCoupon?.code,
          termId: product.effectiveTermId
        });
      }
    };
    $[53] = product;
    $[54] = props;
    $[55] = t24;
  } else {
    t24 = $[55];
  }
  const t25 = pricing.trialDays ? `Start ${pricing.trialDays}-Day Trial` : isSpecialOffer && isRecurringDifferent ? "Select Special Offer" : "Select";
  let t26;
  if ($[56] !== t23 || $[57] !== t24 || $[58] !== t25) {
    t26 = <Button as={NextLink} rightIcon={t22} size="lg" variant="cta" width="full" href={t23} onClick={t24}>{t25}</Button>;
    $[56] = t23;
    $[57] = t24;
    $[58] = t25;
    $[59] = t26;
  } else {
    t26 = $[59];
  }
  let t27;
  if ($[60] !== t21 || $[61] !== t26) {
    t27 = <Center padding={t21} width="full">{t26}</Center>;
    $[60] = t21;
    $[61] = t26;
    $[62] = t27;
  } else {
    t27 = $[62];
  }
  let t28;
  if ($[63] !== product.paywallOptions || $[64] !== props.hideFeatures || $[65] !== props.renderFeatures) {
    t28 = props.renderFeatures ? props.renderFeatures() : <>{!props.hideFeatures && <><HStack opacity={0.75} width="full"><Separator flexGrow={1} /><Text fontFamily="Poppins, sans-serif" fontSize="0.8em" fontWeight={800} textTransform="uppercase" whiteSpace="nowrap">What's Included</Text><Separator flexGrow={1} /></HStack><Wrap gap="0.5em" height="full" justify="center" padding="1em 1em 1.5em 1em" width="full">{product.paywallOptions.features.map(_temp)}</Wrap></>}</>;
    $[63] = product.paywallOptions;
    $[64] = props.hideFeatures;
    $[65] = props.renderFeatures;
    $[66] = t28;
  } else {
    t28 = $[66];
  }
  let t29;
  if ($[67] !== props.containerProps || $[68] !== t13 || $[69] !== t2 || $[70] !== t20 || $[71] !== t27 || $[72] !== t28 || $[73] !== t3 || $[74] !== t4) {
    t29 = <VStack bgColor="colorPalette.muted" borderColor="colorPalette.border" borderRadius="md" borderWidth={t2} boxShadow={t3} flex={1} flexGrow={1} gap={0} justify="stretch" marginY={t4} maxWidth={t5} {...t6}>{t13}{t20}{t27}{t28}</VStack>;
    $[67] = props.containerProps;
    $[68] = t13;
    $[69] = t2;
    $[70] = t20;
    $[71] = t27;
    $[72] = t28;
    $[73] = t3;
    $[74] = t4;
    $[75] = t29;
  } else {
    t29 = $[75];
  }
  return t29;
};
function _temp(feature, idx) {
  return <Badge key={idx} fontSize="12px" paddingX={2}>{feature.title}</Badge>;
}